(function () {
    "use strict";

    // @ngInject
    function NetworkEditProfileControllerCtor($scope, $document,$timeout, $injector, AppStates, ModalService, AnalyticsService, CompanyService, UsersManager, NetworkManager, NetworkOnboardingService, UIUtils, _) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkEditProfileController';

        this.$document = $document;
        this.$timeout = $timeout;
        this.UsersManager = UsersManager;
        this.NetworkManager = NetworkManager;
        this.ModalService = ModalService;
        this.CompanyService = CompanyService;
        this.AnalyticsService = AnalyticsService;
        this.NetworkOnboardingService = NetworkOnboardingService;
        this.AppStates = AppStates;
        this.UIUtils = UIUtils;

        this.user = this.NetworkManager.getNetworkCurrUser(true);
        this.companyTypes = this.CompanyService.getCompanyTypesEnum();

        this.locationGeocoded = false;

        AnalyticsService.trackPageView(this, 'network edit user profile', this.analyticsProperties());

        // set companytype enum
        var selectedCompanyType = this.CompanyService.companyTypeEnum[0];
        this.CompanyService.companyTypeEnum.forEach(function (type) {
            if (this.user.network.vendor_type === type.key) {
                this.selectedCompanyType = type;
                return;
            }

        }.bind(this));

        this.selectedCompanyType = this.CompanyService.getSelectedCompanyTypeFromEnum(this.user.network);

        this.isImageLoading = false;
        this.isSavingProfile = false;
        this.dropdownChanged = false;
        this.setUserData();

        this.user.on("network_user_success", function () {
            this.setUserData();
            this.selectedCompanyType = this.CompanyService.getSelectedCompanyTypeFromEnum(this.user.network);

            // don't show onboarding version of edit profile if there is location
            if (this.user &&
                this.user.network &&
                this.user.network.coordinates &&
                this.user.network.coordinates.length &&
                this.user.network.formatted_address) {
                this.isOnboardingFlow = false;
            } else {
                this.isOnboardingFlow = this.NetworkOnboardingService.isOnboardingOnUserProfile(this.user);
            }
        }.bind(this));

        if (!this.userData.vendor_type) {
            this.setVendorType(this.selectedCompanyType);
        }

        angular.element('#user-profile-affiliation-rts-chapter').autocomplete({

            source: function getRtsChapters(request, response) {
                NetworkManager.getRtsChapters(request.term).then(function success(resp) {
                    var results = _.map(resp.data, function(elm) {return elm.name;});
                    response(results);
                });
            },

            select: function(event, ui) {
                $scope.$apply(function() {
                    this.userProfileForm.affiliationRtsChapter.$setValidity("notSelected", true);
                }.bind(this));
            }.bind(this),

            change: function(event, ui) {
                if (!ui.item) {
                    $scope.$apply(function() {
                        this.userProfileForm.affiliationRtsChapter.$setValidity("notSelected", false);
                    }.bind(this));
                }
            }.bind(this),

            minLength: 3,
            delay: 500
        });
    }

    Controllers.NetworkEditProfileController = Class(Controllers.BaseController, {

        constructor: NetworkEditProfileControllerCtor,

        updateProfileImage: function updateProfileImage() {

            this.ModalService.openUploadProfilePhotoModal(this.user)
                .then(function (files) {
                    this.isImageLoading = true;
                    files[0]['fileModelUpdatePromise'].then(function () {
                        this.isImageLoading = false;
                    }.bind(this))
                        .catch(function () {
                            this.isImageLoading = false;
                        });
                }.bind(this))
                .catch(function (error) {
                        this.isImageLoading = false;
                    }.bind(this)
                );
        },

        update: function update($event) {
            $event.preventDefault();

            var self = this;
            self.submittedOnce = true;
            if(!this.userProfileForm.$valid){
                return;
            }

            this.isSavingProfile = true;

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_update_user_profile, this.analyticsProperties(this.userData));

            this.NetworkManager.updateNetworkUserProfile(this.user, this.userData).then(
                function updateNetworkUserProfileSuccess(resp) {

                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_user_profile, this.analyticsProperties());

                    // Clear validations
                    this.userProfileForm.$setPristine();
                    this.dropdownChanged = false;

                    if (this.isOnboardingFlow) {
                        this.NetworkManager.setNetworkOnboardingStepComplete(this.NetworkOnboardingService.OnboardingSteps.userProfile);
                        this.isOnboardingFlow = false;
                        this.goToState(this.AppStates.root_network_opportunities);
                        return;
                    }
                    this.goToState(this.AppStates.root_network_my_profile);

                }.bind(this),
                function createEventError(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_user_profile, this.analyticsProperties(resp));
                    this.lastError = resp.data.error_message || resp.data;
                }.bind(this))
                .finally(function finallyHandler() {
                    this.isSavingProfile = false;
                }.bind(this));
        },

        setVendorType: function setVendorType(type) {
            this.userData.vendor_type = type.key;
            this.selectedCompanyType = type;
            this.dropdownChanged = true;
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_edit_user_profile_state, this.analyticsProperties(type));
        },

        isFormDirty: function isFormDirty() {
            if (!this.isOnboardingFlow) {
                return ((this.userProfileForm.$dirty || this.dropdownChanged) && this.userProfileForm.$valid);
            } else {
                return this.userProfileForm.$valid;
            }
        },

        cancel: function cancel() {

            if (this.isOnboardingFlow) {
                this.NetworkManager.setNetworkOnboardingStepComplete(this.NetworkOnboardingService.OnboardingSteps.userProfile);
            }

            this.goToState(this.AppStates.root_network_my_profile);
        },

        analyticsProperties: function analyticsProperties(analytics) {
            var properties = {};
            properties.isOnboardingFlow = this.isOnboardingFlow;

            if (analytics) {
                properties = this.extend(properties, analytics);
            }

            return properties;
        },

        extend: function extend(obj, src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) {
                    obj[key] = src[key];
                }
            }
            return obj;
        },

        setUserData: function setUserData(user) {
            this.userData = {
                _id: this.user._id,
                full_name: this.user.network.full_name,
                about: this.user.network.about,
                address_components: this.user.network.address_components,
                formatted_address: this.user.network.formatted_address,
                city: this.user.network.city,
                state: this.user.network.state,
                country: this.user.network.country,
                company_name: this.user.network.company_name,
                website_url: this.user.network.website_url,
                facebook_url: this.user.network.facebook_url,
                pinterest_url: this.user.network.pinterest_url,
                snapchat_url: this.user.network.snapchat_url,
                instagram_url: this.user.network.instagram_url,
                vendor_type: this.user.network.vendor_type,
                looking_for: this.user.network.looking_for,
                coordinates: this.user.network.coordinates,
                affiliation_rts: this.user.network.affiliation_rts,
                affiliation_rts_chapter: this.user.network.affiliation_rts_chapter
            };

            this.locationGeocoded = this.userData.coordinates ? this.userData.coordinates.length > 0 : false;

            if (this.locationGeocoded && !this.userData.formatted_address) {
                this.userData.formatted_address = [this.userData.city, this.userData.state, this.userData.country].filter(Boolean).join(', ');
            }
        },

        checkLocationValidation: function checkLocationValidation() {
            var locationValid = this.locationGeocoded && this.userData.coordinates && this.userData.formatted_address;

            this.userProfileForm.location.$setValidity("notSelected", locationValid);
        },

        locationChanged: function locationChanged() {
            this.locationGeocoded = false;
        },

        locationBlurred: function locationBlurred(){
            this.checkLocationValidation();
        },

        updateLocation: function updateLocation(geocodeResult) {
            this.userData.address_components = geocodeResult.address_components;
            this.userData.formatted_address = geocodeResult.formatted_address;
            this.userData.city = this.UIUtils.getCityFromGeoAddrComponentsLongName(geocodeResult.address_components);
            this.userData.state = this.UIUtils.getStateCodeFromGeoAddrComponentsShortName(geocodeResult.address_components);
            this.userData.country = this.UIUtils.getCountryFromGeoAddrComponents(geocodeResult.address_components);

            var longitude = geocodeResult.geometry.location.lng();
            var latitude = geocodeResult.geometry.location.lat();
            // MongoDB stores geospatical coordinates as long, lat
            this.userData.coordinates = [longitude, latitude];

            this.locationGeocoded = true;
            this.userProfileForm.location.$setValidity("notSelected", true);
        },

        affiliationRtsChange: function affiliationRtsChange(){
            if (this.userData.affiliation_rts){
                this.$timeout(function () {
                    this.$document.find('#user-profile-affiliation-rts-chapter').focus();
                    this.userProfileForm.affiliationRtsChapter.$setValidity("notSelected", false);
                }.bind(this), 30);

            }else{
                this.userData.affiliation_rts_chapter = '';
                this.userProfileForm.affiliationRtsChapter.$setValidity("notSelected", true);
            }
        }
    });
}());
